module.exports = __webpack_public_path__ + "static/media/LandingGroup1.a47598d1.gif";